(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awards"] && !window.DesignMode) return;
  try {
    

// if(typeof window.IntersectionObserver !== 'undefined') {
//   let options = {
//     threshold: [0.5, 1]
//   }
//   const targets = document.querySelectorAll('.section__listt');
//   const locker = document.querySelector('.awards_banner_media');
//   function handleIntersection(entries) {
//     entries.map((entry) => {
//       if (entry.isIntersecting) {
//         entry.target.current = entry.target.dataset.swap;
//         document.querySelector(".awards_banner_media ." + entry.target.current).classList.add("active");
//       } else {
//         document.querySelector(".awards_banner_media ." + entry.target.current).classList.remove("active");
//       }
//     });
//   }
//   const observer = new IntersectionObserver(handleIntersection, options);
//   targets.forEach(target => observer.observe(target));
// } else {
// }


  
// if (typeof window.IntersectionObserver !== 'undefined') {
//   let options = {
//     threshold: Array.from({ length: 101 }, (_, i) => i / 100), // Create thresholds from 0 to 1
//   };

//   const targets = document.querySelectorAll('.section__listt');
//   const images = document.querySelectorAll('.awards_banner_media img');

//   function handleIntersection(entries) {
//     entries.forEach((entry) => {
//       const swapClass = entry.target.dataset.swap;

//       if (entry.isIntersecting) {
//         images.forEach((img) => img.classList.remove("active"));
//         document
//           .querySelector(`.awards_banner_media .${swapClass}`)
//           ?.classList.add("active");
//       }

//       // Dynamic opacity based on intersection ratio
//       const imageElement = document.querySelector(
//         `.awards_banner_media .${swapClass}`
//       );
//       if (imageElement) {
//         imageElement.style.opacity = entry.intersectionRatio;
//       }
//     });
//   }

//   const observer = new IntersectionObserver(handleIntersection, options);

//   targets.forEach((target) => observer.observe(target));
// }


  
if (window.matchMedia('(min-width: 768px)').matches) {
  if (typeof window.IntersectionObserver !== 'undefined') {
    let options = {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    };
    const targets = document.querySelectorAll('.section__listt');
    const images = document.querySelectorAll('.awards_banner_media img');
    function handleIntersection(entries) {
      entries.forEach((entry) => {
        const swapClass = entry.target.dataset.swap;
        const imageElement = document.querySelector(
          `.awards_banner_media .${swapClass}`
        );
        if (entry.isIntersecting) {
          images.forEach((img) => img.classList.remove("active"));
          imageElement?.classList.add("active");
        }
        if (imageElement) {
          // Force opacity to 1 for image--4.active
          if (swapClass === 'image--4' && entry.isIntersecting) {
            imageElement.style.opacity = 1;
          } else if (entry.intersectionRatio === 1) {
            imageElement.style.opacity = 1; // Fully visible
          } else {
            imageElement.style.opacity = entry.intersectionRatio;
          }
        }
      });
    }
    const observer = new IntersectionObserver(handleIntersection, options);
    targets.forEach((target) => observer.observe(target));
  }
}

$(document).ready(() => {
  var intervalId = setInterval(() => {
    var opa = $('.awards_banner_image.image--1.active');
    opa.css('opacity', '1');
    if (opa.css('opacity') == '1') {
      clearInterval(intervalId);
    }
  }, 100);
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-scroll"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  var $carousel = $('.customer-test'); 
  $carousel.slick({
    slidesToShow: 5,
    slidesToScroll: 1, // Allow smoother transitions, one slide at a time
    centerMode: true,
    arrows: false,
    dots: false,
    speed: 1400,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: false,
    autoplay:false,
    draggable: true, 
    swipeToSlide: true, // Enables free swipe without snapping to fixed positions
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          autoplay: true,
          slidesToShow: 3,
          slidesToScroll: 1, 
        }
      },
      {
        breakpoint: 1024,
        settings: {
           autoplay: false,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 1, 
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1,
          slidesToScroll: 1 
        }
      }
    ]
  });

  function stopAllVideos() {
    $('video.Desktop_video').each(function () {
      this.pause();
      this.currentTime = 0;
    });

    $('iframe').each(function () {
      var player = $(this).get(0);
      if (player && player.contentWindow) {
        player.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    });
  }

  function checkAndPlayActiveSlide() {
    var currentSlide = $('.slick-slide.slick-center');
    var video = currentSlide.find('video.Desktop_video');
    var youtubeVideo = currentSlide.find('iframe');
    var image = currentSlide.find('#sliderImages');

    stopAllVideos(); 

    if (video.length > 0) {
      video.get(0).currentTime = 0;
      video.get(0).play();
      video.off('ended').on('ended', function () {
        $carousel.slick('slickNext'); 
      });
    } else if (youtubeVideo.length > 0) {
      var player = youtubeVideo.get(0);
      if (player && player.contentWindow) {
        player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
    } else if (image.length > 0) {
      setTimeout(function () {
        $carousel.slick('slickNext'); 
      }, 2000);
    }
  }

  $carousel.on('beforeChange', function () {
    stopAllVideos(); 
  });

  $carousel.on('afterChange', function (event, slick, currentSlide) {
    checkAndPlayActiveSlide();

    if (currentSlide === slick.slideCount - 1 && slick.options.infinite) {
      setTimeout(function () {
        $carousel.slick('slickNext'); 
      }, 1500); 
    }
  });

  // Initial check for active slide
  checkAndPlayActiveSlide();

  // Handle iframe autoplay (if any)
  $('.customer-sec.slick-current #video_frame').each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf('autoplay=1') === -1) {
      this.src = iframeSrc + "&autoplay=1";
    }
  });

  // Handle video autoplay (if any)
  $('.customer-sec.slick-current #video_playerSlider').each(function () {
    this.autoplay = true;
    this.play();
  });

  // Handle Play/Pause buttons
  document.querySelectorAll('.sliderpause').forEach(function (button) {
    button.addEventListener('click', function () {
      var videoGet = document.querySelector('.customer-sec.slick-current #video_playerSlider');
      if (videoGet) {
        videoGet.pause();
        this.style.display = 'none'; 
        var playButton = document.querySelector('.customer-sec.slick-current #sliderplay');
        if (playButton) {
          playButton.style.display = 'block'; 
        }
      }
    });
  });

  document.querySelectorAll('.sliderplay').forEach(function (button) {
    button.addEventListener('click', function () {
      var videoGet = document.querySelector('.customer-sec.slick-current #video_playerSlider');
      if (videoGet) {
        videoGet.play();
        this.style.display = 'none'; 
        var playpause = document.querySelector('.customer-sec.slick-current #sliderpause');
        if (playpause) {
          playpause.style.display = 'block'; 
        }
      }
    });
  });
document.querySelectorAll('.unmuting').forEach(function (unmute) {
    unmute.addEventListener('click', function () { 
        const videoContainer = this.closest('.product_video_img'); 
        if (!videoContainer) return;
        
        const videoGet = videoContainer.querySelector('#video_playerSlider');
        const muteButton = videoContainer.querySelector('.muting');

        if (videoGet) {
            videoGet.muted = false;
        }

        this.style.display = 'none';
        if (muteButton) {
            muteButton.style.display = 'block';
        }
    });
});
document.querySelectorAll('.muting').forEach(function (unmute) {
    unmute.addEventListener('click', function () { 
        const videoContainer = this.closest('.product_video_img'); 
        if (!videoContainer) return;
        
        const videoGet = videoContainer.querySelector('#video_playerSlider');
        const muteButton = videoContainer.querySelector('.unmuting');

        if (videoGet) {
            videoGet.muted = true;
        }

        this.style.display = 'none';
        if (muteButton) {
            muteButton.style.display = 'block';
        }
    });
});



});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
        $('.scrolling_text_wrapper').slick({
            dots: false,
            infinite: true,
            speed: 4000,
            slidesToShow: 8.5,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
          responsive: [
                {
                    breakpoint: 786,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

  } catch(e) { console.error(e); }
})();
})();
